import { render, staticRenderFns } from "./use-limit-tab-partial.vue?vue&type=template&id=1933683f"
import script from "./use-limit-tab-partial.vue?vue&type=script&lang=js"
export * from "./use-limit-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports